var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcFormatUnderlined = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Underlined")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "underlined1",
    x: 0,
    y: 0,
    width: 1280,
    height: 885
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.5%",
    width: "100.8%",
    height: "101.1%",
    filterUnits: "objectBoundingBox",
    id: "underlined5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "underlined2",
    x: 0,
    y: 0,
    width: 850,
    height: 586,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.6%",
    y: "-0.7%",
    width: "101.2%",
    height: "101.7%",
    filterUnits: "objectBoundingBox",
    id: "underlined6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M10,14.1666667 C12.7583333,14.1666667 15,11.925 15,9.16666667 L15,2.5 L12.9166667,2.5 L12.9166667,9.16666667 C12.9166667,10.775 11.6083333,12.0833333 10,12.0833333 C8.39166667,12.0833333 7.08333333,10.775 7.08333333,9.16666667 L7.08333333,2.5 L5,2.5 L5,9.16666667 C5,11.925 7.24166667,14.1666667 10,14.1666667 L10,14.1666667 Z M4.16666667,15.8333333 L4.16666667,17.5 L15.8333333,17.5 L15.8333333,15.8333333 L4.16666667,15.8333333 L4.16666667,15.8333333 Z",
    id: "underlined3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "underlined4",
    x: 0,
    y: 0,
    width: 41.6666667,
    height: 41.6666667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "underlined7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "underlined8",
    transform: "translate(-740.000000, -403.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "underlined20",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "underlined9",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "underlined10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#underlined5)",
    xlinkHref: "#underlined1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#underlined1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "underlined11",
    transform: "translate(400.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "underlined14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#underlined2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "underlined12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#underlined6)",
    xlinkHref: "#underlined2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#underlined2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "underlined13",
    mask: "url(#underlined14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "underlined12",
    stroke: "#DFE2E5",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 850,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "underlined19",
    stroke: "none",
    fill: "none",
    transform: "translate(256.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "underlined18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#underlined3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "underlined12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "underlined17",
    mask: "url(#underlined18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.833333, -10.833333)",
    id: "underlined15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "underlined21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#underlined4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "underlined16",
    className: "color-fill",
    fill: "#4F5964",
    xlinkHref: "#underlined4"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFormatUnderlined, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-format-underlined.d98173a4.svg";
export { ForwardRef as ReactComponent };